/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { type FeatureFlagResponse } from 'TYPES/api'

import api from '../api'

const featureFlagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    featureFlags: builder.query<FeatureFlagResponse[], void>({
      query: () => ({
        url: 'api/feature-flags',
        method: 'GET',
      }),
    }),
  }),
})

export const { useFeatureFlagsQuery } = featureFlagsApi
